import { VStack, ScrollView, Heading, Text, Link } from 'native-base';

export function PrivacyPolicy() {
  const AppName = 'Musicont'
  return (
    <VStack
      flex={1}
    >
      <ScrollView
        _contentContainerStyle={{
          px: "20px",
          mb: "4",
          minW: "72"
        }}
      >
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title1'
          fontFamily='Title1Bold'
          lineHeight='Title1'
          letterSpacing='Title1'
        >
          {`Usage and Privacy Policies`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='center'
          color='Label.Select'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >
          {`Updated on 08/11/2023`}
        </Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`By this electronic instrument, the POLICIES of the ${AppName} application are informed, in accordance with the provisions set out below:`}
        </Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Usage Policies`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`When you download or use the ${AppName} app, the policies, terms of use and conditions that count on this page will automatically apply, so be sure to read them carefully before using the app.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The ${AppName} mobile app is a FREE app that offers its services at NO COST. And it is distinguished that its users use it with no monetary intentions.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Mobile App User ${AppName} does not have permission to:
        - copy or modify the application, in any part of the application;
        - use the brands, logo, own identifications and other intellectual property rights in any way;
        - extract the application's source code;
        - translate the application into other languages or make derivative versions;`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The Developer is committed to ensuring that the application is as useful and efficient as possible. Then he has the right to make changes to the application at any time and for any reason.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`It is the User's responsibility to keep their cell phone in good condition and safe. The Developer recommends that the User does not Jailbreak or Root their phone, which is the process of removing software restrictions and limitations imposed by the official operating system of their device. This can make your phone vulnerable to malware/viruses/malicious programs, compromise your phone's security features, and could mean the ${AppName} app doesn't work properly.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The User needs to ensure that his device remains charged, if it runs out of battery and cannot turn it on to enjoy the services provided by the application, the Developer cannot be held responsible.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The User should be aware that there are certain things for which the Developer is not responsible. Certain app functions will require the app to have an active internet connection. The connection can be Wi-Fi or provided by your mobile network provider, but the Developer cannot be held responsible for the application not working in full functionality if the User does not have access to the internet. If the User is using the application outside of an area with Wi-Fi, remember that the terms of the agreement with your mobile network provider still apply. As a result, the User may be charged by their mobile operator for the cost of data trafficked during connection and access to the application or other third-party charges. By using the application, the User accepts responsibility for such charges, including roaming data charges if the User uses the application outside of their home territory (i.e. region or country).`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`At some point, the Developer will update the application. The app may be available for both Android and iOS operating systems – the requirements for both systems (and for any additional systems to which the app's availability extends) may change, and the User will need to download updates if he wants to keep using the app. . The Developer does not promise that it will always update the application so that it works on a specific version of a particular operating system that the User has installed on its device. However, the User must always accept application updates when offered. There is also the possibility that the Developer wants or is obliged to stop providing the application, and may terminate its use at any time without notice of termination to the User. Unless Developer says otherwise, upon any termination, the rights and licenses granted to Users in these terms will terminate. Upon termination, the User must stop using the application and delete it from his/her device.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`When the User is using the application, it is important to keep in mind that while the Developer strives to ensure that the application is up to date and correct at all times, the Developer relies on third parties who are responsible for providing the information made available. So the Developer is not responsible for any loss, direct or indirect, that the User experiences as a result of fully relying on the services and information provided by the application.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Privacy Policy: Basics`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`This instrument brings the privacy policy of the services provided through the ${AppName} mobile application, showing how the data and information will be managed.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`This privacy policy aims to ensure that any information and data will not be provided, published or marketed under any circumstances. And this page is used to inform Users about the Collection, Use and Disclosure of Personal Information policies. If the User has chosen to use the ${AppName} Application, he/she agrees to the collection and use of information contained in this privacy policy.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >{`Privacy Policy: Data Collection and Use`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`This application does not store any direct or indirect data related to the identification and location of the User of the application.`}</Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The information used in this application is stored in a database with restricted access, which is managed by the Google Firebase online platform. For the proper functioning of the application, third-party services, libraries, tools or frameworks are used that can collect information for the proper functioning of the application. Below we have the Privacy Policy of our main providers of services, libraries, tools, frameworks etc:`}</Text>
        <Text>{'      '}<Link
            href="https://google.com/policies/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Click here for Google's Privacy Policy;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://firebase.google.com/support/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Click here for Firebase Privacy Policy;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://expo.io/privacy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Click here for Expo Privacy Policy;`}</Link></Text>
          <Text>{'      '}<Link
            href="https://nativebase.io/privacy-policy"
            isExternal _text={{
              color: "Label.Tinted"
            }} mt={-0.5} _web={{
              mb: -2
            }}
          >{`- Click here for the NativeBase Privacy Policy.`}</Link></Text>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`These third parties may have to access information to carry out tasks assigned to them. However, they are obligated not to disclose or use the information for any other purpose.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Privacy Policy: Cookies`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. The application does not use these “cookies” explicitly. However, the application may use third-party code and libraries that use “cookies” to collect information.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Privacy Policy: Security`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The developer of this app values your trust and is striving to use legally acceptable means of securing the app. But remember that there is no application that uses the internet, 100% safe and reliable, and it is impossible to guarantee absolute security.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Privacy Policy: Links`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`This Application may contain links to other websites. If you click on a third party link, you will be directed to that website. Please note that these external websites are not operated by the Developer. Therefore, it is advisable for the User to review the Privacy Policy of these sites. The developer has no control over and assumes no responsibility for the content, privacy policies or practices of any third party websites or services.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Privacy Policy: Children and Adolescents.`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`This Application is not intended for this audience. There is no intentional collection of personally identifiable information. If the User is the parent or guardian and is aware that their child has used the application and provided any personal information, please contact us so that the necessary steps can be taken to delete such information.`}</Text>
        <Heading
          margin={1.5}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title2'
          fontFamily='Title2Bold'
          lineHeight='Title2'
          letterSpacing='Title2'
        >
          {`Policy Changes`}
        </Heading>
        <Text
          margin={1.5}
          textAlign='justify'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyRegular'
          lineHeight='Body'
          letterSpacing='Body'
        >{'      '}{`The Developer has the full right to update the policies at any time. Therefore, it is recommended that the User periodically review this page for any changes.`}</Text>
        <Heading
          margin={2}
          textAlign='center'
          color='Label.Primary'
          fontSize='Title3'
          fontFamily='Title3Bold'
          lineHeight='Title3'
          letterSpacing='Title3'
        >
          {`Any questions, suggestions or corrections, please contact:`}
        </Heading>
        <Heading
          textAlign='center'
          color='Label.Primary'
          fontSize='Body'
          fontFamily='BodyBold'
          lineHeight='Body'
          letterSpacing='Body'
        >{`Felipe Sineider Martins\nDeveloper\nsineider@gmail.com`}
        </Heading>
      </ScrollView>
    </VStack>
  );
}